export default {"src":"/_next/static/media/xmr.47158a7d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};